import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSingleDate_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template';
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {filterPaymentView_template} from "./filterPaymentView_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";

declare var ko: any;

export class transactionsPaymentList_template extends vnTemplate{

    protected deleteTransactionId: number;

    protected datePicker : filterSingleDate_template;

    protected pagination: pagination_template;
    protected filterPaymentView: filterPaymentView_template;
    protected filterPaymentAccount: filterDropdown_template;
    public validationsList: validationsList_template;

    protected getTemplateHtml(): string{

        return `
            <div class="sub-header w-justify">
                <div class="w-left">
                    <label class="form-label" for="filterPaymentAccount">Account: </label>` + this.filterPaymentAccount.getHtmlBuild() + `
                     
                </div>
                <div class="w-center">
                    <label for="singleDatePicker" class="form-label">payment date</label>
                    ` + this.datePicker.getHtmlBuild() + `
                </div>
                <div class="w-right">
                    <button data-bind="click: onClickExecutePayment" class="btn white border icon i-execute" type="button">Execute Payment</button>
                    <button data-bind="click: onClickReversePayment, text: '  Revert Last Payment (' + lastPayDate() + ')'" class="btn border icon i-revert" type="button"></button>  
                </div>
            </div>
            
            ` + this.validationsList.getHtmlBuild() + `
            
            <div class="list-header w-justify">
            
                
                <div class="w-left">
                   ` + this.filterPaymentView.getHtmlBuild() + `
                </div>
                <div class="w-center">
                    
                </div>
                <div class="w-right">
                    <div data-bind="visible: !isSummaryVisible()">            
                         ` + this.pagination.getHtmlBuild() + `
                    </div> 
                </div>
                          
            </div>
            
            <div class="w-list-results" id="list-results" data-bind="visible: !isSummaryVisible()">
            
                <table class="list-results">
                    <thead>
                        <tr>
                            <!--<th><span>place on hold</span></th>-->
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'currency') }, css: { 'list-sort-desc': orderByAndDirection()=='currency_DESC', 'list-sort-asc': orderByAndDirection()=='currency_ASC'}">currency</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'type') }, css: { 'list-sort-desc': orderByAndDirection()=='type_DESC', 'list-sort-asc': orderByAndDirection()=='type_ASC'}">type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC'}">name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'user_fullName') }, css: { 'list-sort-desc': orderByAndDirection()=='user_fullName_DESC', 'list-sort-asc': orderByAndDirection()=='user_fullName_ASC'}">user</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'project_name') }, css: { 'list-sort-desc': orderByAndDirection()=='project_name_DESC', 'list-sort-asc': orderByAndDirection()=='project_name_ASC'}">article</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'brand_name') }, css: { 'list-sort-desc': orderByAndDirection()=='brand_name_DESC', 'list-sort-asc': orderByAndDirection()=='brand_name_ASC'}">brand</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'creation_type') }, css: { 'list-sort-desc': orderByAndDirection()=='creation_type_DESC', 'list-sort-asc': orderByAndDirection()=='creation_type_ASC'}">creation type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'action_type') }, css: { 'list-sort-desc': orderByAndDirection()=='action_type_DESC', 'list-sort-asc': orderByAndDirection()=='action_type_ASC'}">action type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'entry_type') }, css: { 'list-sort-desc': orderByAndDirection()=='entry_type_DESC', 'list-sort-asc': orderByAndDirection()=='entry_type_ASC'}">entry type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'status') }, css: { 'list-sort-desc': orderByAndDirection()=='status_DESC', 'list-sort-asc': orderByAndDirection()=='status_ASC'}">status</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'payment_date') }, css: { 'list-sort-desc': orderByAndDirection()=='payment_date_DESC', 'list-sort-asc': orderByAndDirection()=='payment_date_ASC'}">payment date</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreation') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreation_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreation_ASC'}">creation date</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateScheduled') }, css: { 'list-sort-desc': orderByAndDirection()=='dateScheduled_DESC', 'list-sort-asc': orderByAndDirection()=='dateScheduled_ASC'}">schedule date</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: transactions">
                        <tr>
                            <!--<td class="hold"><button data-bind="event: { click: $parent.onClickHold }" type="button" class="icon i-edit"></button></td>-->
                            <td class="amount"><span data-bind="text: amount"></span></td>
                            <td class="currency"><span data-bind="text: currency ? currency.currency : '-' "></span></td>
                            <td class="type"><span data-bind="text: type ? type.name  : '-'"></span></td>
                            <td class="name"><span data-bind="text: name"></span></td>
                            <td class="user_fullName"><span data-bind="text: user ? user.valnet_user.fullName : '-'"></span></td>
                            <td class="project_name"><span data-bind="text: item ? item.title : '-'"></span></td>
                            <td class="brand_name"><span data-bind="text: $parent.brand().name"></span></td>
                            <td class="creation_type"><span data-bind="text: creationType ? creationType.name : '-'"></span></td>
                            <td class="action_type"><span data-bind="text: actionType ? actionType.name : '-'"></span></td>
                            <td class="entry_type"><span data-bind="text: entryType ? entryType.name : '-'"></span></td>
                            <td class="status"><span data-bind="text: status ? status.name : '-'"></span></td>
                            <td class="payment_date"><span data-bind="text: payment ? payment.dateExcution : '-'"></span></td>
                            <td class="dateCreation"><span data-bind="text: dateCreation"></span></td>
                            <td class="dateScheduled"><span data-bind="text: dateScheduled"></span></td>
                        </tr>
                    </tbody>
                </table>
            
            </div>
            
            <div class="w-list-results" id="summary-results" data-bind="visible: isSummaryVisible()">
            
                <table class="list-results">
                     <thead>
                     <tr>
                            <th><span>details</span></th>
                            <th><span>user</span></th>
                            <th><span>Paypal ID</span></th>
                            <th><span>currency</span></th>
                            <th><span>total paid</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: users">
                        <tr>
                            <td class="details button"><button data-bind="event: { click: $parent.onClickDetails }, css: { 'is-open' : showDetails }" type="button" class="icon i-triangle"></button></td>
                            <td class="user_fullName left-align"><span data-bind="text: user_fullName"></span></td>
                            <td class="paymentEmail left-align"><span data-bind="text: paymentEmail"></span></td>
                            <td class="currency right-align"><span data-bind="text: currency"></span></td>
                            <td class="total right-align"><span data-bind="text: total"></span></td>
                        </tr>
                        <tr class="parent-tr">
                            <td colspan="5">
                                <div data-bind="css: { 'is-open' : showDetails }" class="w-list-child">
                                    <table class="list-child">
                                        <!--<thead>
                                            <tr>
                                                <th><span>name</span></th>
                                                <th><span>amount</span></th>
                                            </tr>
                                        </thead>-->
                                        <tbody data-bind="foreach: transactions">
                                            <tr>
                                                <td class="left-align"><span data-bind="text: entry_type"></span></td>
                                                <td class="left-align"><span data-bind="text: project_name"></span></td>
                                                <td class="left-align"><span data-bind="text: idYoutube"></span></td>
                                                <td class="left-align"><span data-bind="text: dateCreation"></span></td>
                                                <td class="right-align amount"><span data-bind="text: amount"></span></td>
                                            </tr>
                                        </tbody>
                                    </table>    
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            
            </div>
            
            
            <div id="pay-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                        
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Execute Payment Transactions</h3>
                            <button data-bind="event: { click: onClickPaymentDialogHide }" type="button" class="close-button icon i-close-2"></button>
                        </div>
                   
                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">This action is irreversible</p>
                                <p class="form-text">Are you sure you want to pay all the existing transactions?</p>
                            </div>
                         </div>
                
                        <div class="form-footer">
                            <button data-bind="event: { click: onClickPaymentDialogHide }" class="btn" type="button">Cancel</button>
                            <button data-bind="event: { click: onClickPaymentConfirm }" class="btn highlight" type="button">Pay</button>
                        </div>
                    </div>
                   
                </div>
            </div>
            <div id="reverse-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                        
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Revert Payment</h3>
                            <button data-bind="event: { click: onClickReverseDialogHide }" type="button" class="close-button icon i-close-2"></button>
                        </div>
                   
                        <div class="form-body">
                             <div class="form-group">
                                <p class="form-text">This action is irreversible</p>
                                <p class="form-text">Are you sure you want to revert the last payment?</p>
                             </div>
                         </div>
                
                        <div class="form-footer">
                            <button data-bind="event: { click: onClickReverseDialogHide }" class="btn" type="button">Cancel</button>
                            <button data-bind="event: { click: onClickReverseConfirm }" class="btn highlight" type="button">Confirm</button>
                        </div>
                    </div>
                   
                </div>
            </div>
            <div id="none-pay-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                        
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Execute Payment Transactions</h3>
                            <button data-bind="event: { click: onClickPaymentDialogHide }" type="button" class="close-button icon i-close-2"></button>
                        </div>
                   
                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">There are no transactions to pay!</p>
                             </div>
                         </div>
                
                        <div class="form-footer">
                            <button data-bind="event: { click: onClickPaymentDialogHide }" class="btn" type="button">ok</button>
                        </div>
                    </div>
                   
                </div>
            </div>
            `;
    }

    protected initPartial(): void {

        this.datePicker = new filterSingleDate_template("filterDate", this.getTemplateViewModel(), this.caller);

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.filterPaymentView = new filterPaymentView_template("filterPaymentView", this.getTemplateViewModel(), this.caller);

        this.filterPaymentAccount = new filterDropdown_template("filterPaymentAccount", this.getTemplateViewModel(), this.caller);
        this.filterPaymentAccount.setLabel("Payment Account");

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
    }

    public buildDatePickerCalendar(){
        this.datePicker.buildCalendarWithoutTime();
    }

    protected getTemplateName(): string{
        return "transactionsPaymentList-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
    	return ["w-content"];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return  {    orderBy: ko.observable("dateScheduled")
                    ,orderByDirection: ko.observable("DESC")
                    ,transactions: ko.observableArray([])
                    ,users: ko.observableArray([])
                    ,transactionIds: ko.observableArray([])
                    ,lastPayDate: ko.observable("")
                    ,brand: ko.observable({})
                    ,orderByAndDirection: ko.observable("dateScheduled_DESC")
                    ,isSummaryVisible: ko.observable(false)
                    ,onClickReorder : function(value, data, event){ huit_neuf_this.onClickReorder(value, data, event); }
                    ,onClickPaymentConfirm: function(data, event){ huit_neuf_this.onClickPaymentConfirm(); }
                    ,onClickPaymentDialogHide: function(data, event){ huit_neuf_this.onClickPaymentDialogHide(); }
                    ,onClickReverseConfirm: function(data, event){ huit_neuf_this.onClickReverseConfirm(); }
                    ,onClickReverseDialogHide: function(data, event){ huit_neuf_this.onClickReverseDialogHide(); }
                    ,onClickExecutePayment: function(){ huit_neuf_this.onClickExecutePaymentDialogShow(); }
                    ,onClickReversePayment: function(){ huit_neuf_this.onClickReversePaymentDialogShow(); }
                    ,onClickHold: function(){ huit_neuf_this.onClickHold(); }
                    ,onClickDetails: function(data,event){ huit_neuf_this.onClickDetails(data); }
                };
    }

    public onClickReorder(value, data, event){

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)){
            if( data.orderByDirection() == "DESC" ){
                data.orderByDirection("ASC");
            }
            else{
                data.orderByDirection("DESC");
            }
        }
        else{
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.transactionPaymentListReorder();
    }

    public onClickEdit(data){
        this.caller.editTransaction(data);
    }

    public onClickDetails(data) {
        if (data.showDetails){
            data.showDetails = false;
            data.transactions = [];
            //force refresh - if you don't do this the foreach HTML will not be updated.
            var tmp = this.getTemplateViewModel().users();
            this.getTemplateViewModel().users([]);
            this.getTemplateViewModel().users(tmp);
        }
        else{
            data.showDetails = true;
            this.caller.getUserPaymentDetails(data.user_id);
        }
    }

    public setLastPayDate(lastPayDate){
        this.viewModel[this.idElement].lastPayDate(lastPayDate);
    }

    public setBrand(brand) {
        this.viewModel[this.idElement].brand(brand);
    }

    public setTransactions(transactions){

        this.viewModel[this.idElement].transactions(transactions);

        let trxIds = [];
        if(transactions) {
            for (let t of transactions) {
                trxIds.push(t.id);
            }
        }

        this.viewModel[this.idElement].transactionIds(trxIds);
    }

    public setUsers(users){

        this.viewModel[this.idElement].users(users);

    }

    public onClickPaymentConfirm() {
        this.togglePaymentDialogVisibility();

        this.caller.pay();
    }
    public onClickPaymentDialogHide() {
        this.togglePaymentDialogVisibility();
    }

    public onClickReverseConfirm() {
        this.toggleReverseDialogVisibility();

        this.caller.reverse_payment();
    }
    public onClickReverseDialogHide() {
        this.toggleReverseDialogVisibility();
    }

    public onClickHold() {
        //this.togglePaymentDialogVisibility();
    }

    public onClickExecutePaymentDialogShow() {
        this.togglePaymentDialogVisibility();
    }

    public onClickReversePaymentDialogShow() {
        this.toggleReverseDialogVisibility();
    }

    public togglePaymentDialogVisibility() {
        let transactions = this.viewModel[this.idElement].transactions();

        if(transactions.length > 0){
            document.getElementById('pay-dialog').classList.toggle('is-visible');
        }else{
            this.caller.showNoneTransactionToPay();
        }
    }

    public toggleReverseDialogVisibility() {
        document.getElementById('reverse-dialog').classList.toggle('is-visible');
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/transactionsPaymentList_template.ts